import { RecordSource, Store } from 'relay-runtime'

/* eslint-disable no-underscore-dangle -- special case */
const getRecords = () => window.__RELAY_PAYLOADS__
/* eslint-enable no-underscore-dangle */
const queryRecords = getRecords()

const source = new RecordSource(queryRecords)
export default new Store(source)
